import { render, staticRenderFns } from "./O365Login.vue?vue&type=template&id=82fa6964&scoped=true"
import script from "./O365Login.vue?vue&type=script&lang=js"
export * from "./O365Login.vue?vue&type=script&lang=js"
import style0 from "./O365Login.vue?vue&type=style&index=0&id=82fa6964&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82fa6964",
  null
  
)

export default component.exports